module.exports = __webpack_public_path__ + "static/media/New_Series_3_Ep5_Future_farms_Mobile.93593b7d.jpg";